import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "fileInput"]

  connect() {
    this.fileInputTarget.addEventListener("change", this.handleFileSelect.bind(this))
  }

  disconnect() {
    this.fileInputTarget.removeEventListener("change", this.handleFileSelect.bind(this))
  }

  selectFile() {
    this.fileInputTarget.click()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]

    if (!file) {
      return
    }

    const validTypes = ["text/csv", "text/plain", "application/vnd.ms-excel"]
    const fileExtension = file.name.split(".").pop().toLowerCase()

    if (!validTypes.includes(file.type) && !["csv", "txt"].includes(fileExtension)) {
      alert("Please select a CSV or text file")
      this.fileInputTarget.value = ""
      return
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB")
      this.fileInputTarget.value = ""
      return
    }

    this.submitForm()
  }

  submitForm() {
    this.formTarget.requestSubmit()
    this.fileInputTarget.value = ""
  }
}
